import { FC } from "react";

export const PublicLayout: FC = () => {
  return <div></div>;
};
